import { Button } from './ui/Button';

const SUPPORT_MAILTO =
  'mailto:itservicedesk@aurora-group.invalid?subject=UCP%20workforce%20admission';

/**
 * PRO-1440 / ADR-071 — deny view when the workforce baseline flag is on and the
 * caller is not a member of All Staff, or their staff_users row is disabled.
 * Deliberately has no "Request access" CTA (that path is for zero-role configured
 * staff, not admission failures).
 */
export function WorkforceAdmissionDeniedView({
  reason,
  onSignOut,
}: {
  reason: 'not_member' | 'disabled';
  onSignOut: () => void;
}) {
  const heading = reason === 'disabled' ? 'Account disabled' : 'Workforce access denied';
  const body =
    reason === 'disabled'
      ? 'Your staff account is disabled. Contact the IT Service Desk if you believe this is a mistake.'
      : 'You have signed in successfully, but you are not a member of the All Staff group that admits people to TAG Operations.';

  return (
    <section aria-labelledby="workforce-admission-denied-heading">
      <h2 id="workforce-admission-denied-heading">{heading}</h2>
      <p>{body}</p>
      <p>
        Contact the IT Service Desk:{' '}
        <a href={SUPPORT_MAILTO}>itservicedesk@aurora-group</a>.
      </p>
      <Button variant="secondary" onClick={onSignOut}>
        Sign out
      </Button>
    </section>
  );
}
